<div  id="outer-info-pop-up" class="outer {{disabled ? 'info-popup-disabled' : ''}}" attr.data-testid="{{testId}}">
    <div *ngIf="!isCustomImage; else customImage" (click)="open($event)"  class="info-toggle-logo {{isPopedUp ? 'info-toggle-active' : ''}}"></div>
    <ng-template #customImage >
        <div (click)="open($event)"  class="{{customImageCss}}"></div>
    </ng-template>
    <ng-content></ng-content>
    <div [width]="5"></div>
    <div class="{{textCls}}" attr.data-testid="{{testId}}-text">  {{logoText}}</div>  
</div>  
